module.exports = (__parcel__import__("28ryk")).then(() => parcelRequire('4MKVl'));